function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPrintRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 27.599h12V20.4H10v7.199zM8 27.6c0 1.326.896 2.4 2 2.4h12c1.104 0 2-1.074 2-2.4V18H8v9.6zM6 16h2v-2H6v2zM10 4h12v4h2V4a2 2 0 00-2-2H10a2 2 0 00-2 2v4h2V4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 10H6a4 4 0 00-4 4v11h4v-2H4v-9c0-1.103.897-2 2-2h20c1.103 0 2 .897 2 2v9h-2v2h4V14a4 4 0 00-4-4z",
    fill: props.color
  }));
}

export default SvgIconPrintRexOutline;